import React from "react";
import { AppBar, Toolbar, CssBaseline } from "@mui/material";
import { Box } from "@mui/material";
import styles from "./navbarComponent.module.scss";
import NavMenuItem from "./component/navMenuItem/NavMenuItem";
import { useNavbarContext } from "./NavbarCotext";

function NavbarComponent() {
  const { setNavState } = useNavbarContext();

  const setSelectedMenuName = (val) => {
    setNavState({ selectedNavItem: val });
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      className={styles.appNavBar}
      style={{ zIndex: "800" }}
      data-testid="NavbarComponent"
      role ='group'
    >
      <Box className={styles.navBarWrapper}>
        <CssBaseline />
        <Toolbar className={styles.customizeToolbar} data-testid='parent'>
          <Box className={styles.navLinksContainer} >
            <NavMenuItem
              link="/"
              name={"Dashboard"}
              onNavClick={() => setSelectedMenuName("Dashboard")}
              iconStyle={`${styles.dashboardIcon}`}
              
            />
            <NavMenuItem
              link="/dealers"
              name={"Dealers"}
              onNavClick={() => setSelectedMenuName("Dealers")}
              iconStyle={`${styles.dealerIcon} dealersLink`}
            />

            <NavMenuItem
              link="/vehicles"
              name={"Vehicles"}
              onNavClick={() => setSelectedMenuName("Vehicles")}
              iconStyle={`${styles.carIcon}`}
            />
            <NavMenuItem
              link="/settings"
              name={"Settings"}
              onNavClick={() => setSelectedMenuName("Settings")}
              iconStyle={`${styles.settingsIcon}`}
            />

            <NavMenuItem
              link="/reports"
              name={"Reports"}
              onNavClick={() => setSelectedMenuName("Reports")}
              iconStyle={`${styles.reportIcon}`}
            />
            <NavMenuItem
              link="/exports"
              name={"Downloads"}
              iconStyle={`${styles.exportIcon}`}
              isDropDown={true}
              menu_list={[
                { title: "Dealers data", link: "/export_dealers" },
                { title: "Vehicle data", link: "/export_vehicle_lists" },
              ]}
            />
             <NavMenuItem
              link="/exact"
              name={"Exact"}
              onNavClick={() => setSelectedMenuName("Exact")}
              iconStyle={`${styles.exactIcon}`}
            />
          </Box>
        </Toolbar>
      </Box>
    </AppBar>
  );
}
export default NavbarComponent;
